import React, { useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { useApp } from '../../hooks/use-app';
import SignaturePreviewDialog from './media/signature-preview-dialog';

interface SignaturePreviewItemProps {
  mediaID: string;
  thumbnailURL: string;
}

/**
 * Self-contained signature thumbnail + preview modal.
 *
 * Signatures don't have MediaItemValue instances, so they can't use the
 * shared ModalMediaViewer pipeline (which relies on instanceof checks in
 * displayableItemForItem / metadataLoaderForItem). Instead, this component
 * replicates the legacy SignatureElementView viewer: click the thumbnail
 * to open a simple modal showing the full-resolution signature image.
 */
const SignaturePreviewItem: React.FC<SignaturePreviewItemProps> = ({ mediaID, thumbnailURL }) => {
  const [viewing, setViewing] = useState(false);
  const ctx = useApp();

  const previewURL = ctx.dataSource?.source?.getSignaturePreviewURL(mediaID) ?? '';

  const handleOpen = useCallback(() => {
    setViewing(true);
  }, []);

  const handleClose = useCallback(() => {
    setViewing(false);
  }, []);

  return (
    <>
      <ButtonBase onClick={handleOpen} sx={{ borderRadius: '5px' }}>
        <Box
          component="img"
          src={thumbnailURL}
          loading="lazy"
          sx={{
            width: 80,
            height: 80,
            objectFit: 'cover',
            borderRadius: '5px',
            display: 'block',
          }}
        />
      </ButtonBase>

      <SignaturePreviewDialog
        open={viewing}
        onClose={handleClose}
        previewURL={previewURL}
      />
    </>
  );
};

export default SignaturePreviewItem;
